import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type LeftArrowProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function LeftArrowIcon({
  className,
  pathClassName = "stroke-black",
  ...props
}: LeftArrowProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      className={className}
    >
      <Path
        d="M15.583 4l-6.587 6.587a2.013 2.013 0 000 2.826L15.583 20"
        stroke="#718096"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default LeftArrowIcon;
